import { render, staticRenderFns } from "./mentw.vue?vue&type=template&id=703f21f9&scoped=true&"
import script from "./mentw.vue?vue&type=script&lang=js&"
export * from "./mentw.vue?vue&type=script&lang=js&"
import style0 from "./mentw.vue?vue&type=style&index=0&id=703f21f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f21f9",
  null
  
)

export default component.exports